<template>
  <main class="volunteer-impact-report">
    <VolunteerImpactCard
      :person-id="personId"
      :location-id="locationId"
      :person-name="personName"
      :is-admin-view="true"
    />
  </main>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import VolunteerImpactCard from '@/components/VolunteerImpact/VolunteerImpactCard.vue'

const route = useRoute()
const personId = computed(() => route.params.personId)
const locationId = computed(() => route.query.locationid || null)
const personName = computed(() => route.query.personName || '')
</script>

<style scoped>
.volunteer-impact-report {
  max-width: 1440px;
  margin: 0 auto;
  padding: 20px;
}

@media (max-width: 620px) {
  .volunteer-impact-report {
    padding: 8px;
  }
}
</style>